import { QueryKey } from "@tanstack/react-query";

export const USER_KEY: QueryKey = ["user"];
export const AUTH_PROVIDERS_KEY: QueryKey = ["auth", "providers"];

export const LANGUAGES_KEY: QueryKey = ["translation", "languages"];

export const RESUME_KEY: QueryKey = ["resume"];
export const RESUMES_KEY: QueryKey = ["resumes"];
export const RESUME_PREVIEW_KEY: QueryKey = ["resume", "preview"];

export const PAYMENT_DETAILS_KEY: QueryKey = ["payment", "details"];
export const PRACTICE_SESSIONS_KEY: QueryKey = ["practice", "sessions"];
export const PRACTICE_SESSION_KEY = (sessionId: string): QueryKey => [
  "practice",
  "session",
  sessionId,
];
